import styled from "styled-components";

export const FollowUpView = styled.div`
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(35, 34, 157, 0.17);
    padding: 10px 20px;
    justify-content: space-between;
    .filters-button {
      display: flex;
      align-items: center;
      display: flex;
      padding: 10px;
      align-items: center;
      border-radius: 43px;
      border: 1px solid #6c6bcc;
      color: #6c6bcc;
      cursor: pointer;
      &__icon {
        margin-right: 10px;
      }
    }

    .filter-state {
      display: flex;
      cursor: pointer;
      display: flex;
      background-color: #efeff9;
      padding: 3px;
      border-radius: 56.43px;
    }
  }

  .follow-up-list {
    height: calc(100% - 88px);

    &__top {
      display: flex;
      justify-content: space-between;
      padding: 10px 50px 0 50px;
      color: #707582;
      font-family: "Nunito Sans";
      font-size: 15px;
      font-style: normal;
    }

    &__center {
      height: calc(100% - 0px);
      overflow: auto;
      margin: 10px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }

    .follow-up__item {
      padding: 0px 20px 10px 20px;
    }

    &__bottom {
      display: flex;
      justify-content: center;
      .pagination {
        padding: 17px 0px;
        display: flex;
        align-items: center;
        &__arrow {
          cursor: pointer;
          color: #3e3da3;
          font-size: 12px;
          &--back {
            margin-right: 45px;
          }
          &--next {
            margin-left: 5px;
          }
        }
        &__number {
          cursor: pointer;
          color: #6c6bcc;
          text-align: center;
          font-family: "Nunito Sans";
          font-size: 16px;
          letter-spacing: -0.144px;
          margin-right: 40px;
          &--selected {
            border-bottom: 1px solid #6c6bcc;
          }
        }
      }
      .add-patient {
        cursor: pointer;
        right: 0;
        bottom: 0;
        position: absolute;
        display: flex;
        align-items: center;
        margin: 17px 52px;
        color: #6c6bcc;
        font-family: "Nunito Sans";
        font-size: 17px;
        &__text {
          margin-right: 5px;
        }
        &__icon {
          font-size: 16px;
          opacity: 0.7;
        }
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .buttons-container__caption {
    color: #1f1f52;
    font-size: 17px;
    display: flex;
    align-items: center;

    .caption {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      &__text {
        display: flex;
        font-size: 17px;
        color: #1f1f52;
        width: 100%;

        div {
          display: flex;
          align-items: center;
          margin-left: 10px;
          font-size: 14px;
          font-weight: 400;
          padding: 4px 10px;
          padding-left: 10px;
          padding-right: 15px;
          box-shadow: 0 0 4px 0 #d8d8ea;
          border-radius: 8px;

          i {
            margin-right: 10px;
            font-size: 8px;
            color: #5a7078;
            cursor: pointer;
          }
        }
      }
    }
  }
`;

export const TabItem = styled.div`
  display: flex;
  align-items: center;
  border-radius: 56.43px;
  padding: 5px 20px;
  background-color: ${({ activeTab }) =>
    activeTab ? "#FFFFFF" : "transparent"};
  .item-text {
    /* border-bottom: 1.5px solid ${({ color, activeTab }) =>
      activeTab ? color : "transparent"}; */
    color: ${({ color }) => color};
    font-weight: ${({ activeTab }) => (activeTab ? "800" : "400")};
    /* margin-right: 20px; */
  }

  .item-point {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-left: 5px;
    background-color: ${({ color }) => color};
  }
`;

export const StatusSelector = styled.div`
  width: 297px;
  height: 350px;
  padding: 10px 10px 0px 10px;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px #23229d33;
  background-color: #eeeef7;
  .header {
    font-family: Nunito Sans Bold;
    font-size: 20px;
    padding: 10px 20px;
    color: #1f1f52;
    border-bottom: 2px solid #ffffff;
  }
  .list-groups {
    overflow: auto;
    display: flex;
    flex-direction: column;
    padding: 20px 10px 0px 10px;
    height: calc(100% - 69px);
    margin-bottom: 10px;
    &::-webkit-scrollbar {
      display: none;
    }
    .program-group {
      padding: 20px 10px 10px 10px;
      background-color: #ffffff;
      border-radius: 15px;
      margin-bottom: 10px;
      .group-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        &__text {
          color: #1f1f52;
          font-family: Nunito Sans Bold;
          font-size: 12px;
        }
        &__select {
          color: #2a28d6;
          font-family: Nunito Sans Bold;
          font-size: 12px;
          cursor: pointer;
        }
      }
      .group-stages-list {
        .group-stage {
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 18px 0;
          &__check {
            font-size: 20px;
            color: #2a28d6;
          }
          &__title {
            font-family: Nunito Sans;
            font-size: 18px;
            color: #1f1f52;
            margin-left: 5px;
          }
        }
      }
    }
  }
`;
